export default {
    header: "Orders of {name}",
    error: "An error occurred",
    empty: "No orders found",
    system: "Help Desk",
    orders: {
        name: "Name",
        date: "Date",
        status: "Status",
        approvedBy: "Approved by"
    },
    cta: {
        close: "Close"
    }
}